import axios from "utils/httpClient";

const API = "/api/v1/vehicle/drivers";

export const VehicleDriverService = {
  getAll: () => axios.get(API),
  add: userNames => axios.post(API, { userNames }),
  remove: userName => axios.delete(`${API}/${encodeURIComponent(userName)}`),
  updateOrders: orders => axios.put(`${API}/order`, { orders })
};
